import {LOG_IN, LOG_OUT, LOG_VERIFICAR} from './authTypes';
export function logOut() {
   return {
      type: LOG_OUT
   };
}
export function logIn(usuario, token = '', appInfo = null, configUser = {}) {
   let payload = {
      usuario: {},
      logged: false,
      msg: '',
      token: '',
      appInfo: appInfo,
      configUser: configUser
   };
   if (usuario && usuario.codigo) {
      const fechaVigencia = new Date(usuario.fechaVigencia);
      if (fechaVigencia > new Date()) {
         payload.usuario = usuario;
         payload.logged = true;
         payload.token = token;
      } else {
         payload.msg = 'Su fecha de vigencia ha finalizado.';
      }
   } else {
      payload.msg = 'Usuario o Password incorrectos.';
   }
   return {type: LOG_IN, payload};
}

export function logInPermisivo(usuario, token = '', appInfo = null, configUser = {}) {
   let payload = {
      usuario: {},
      logged: false,
      msg: '',
      token: '',
      appInfo: appInfo,
      configUser: configUser
   };
   if (usuario && usuario.codigo) {
      payload.usuario = usuario;
      payload.logged = true;
      payload.token = token;
   } else {
      payload.msg = 'Usuario o Password incorrectos.';
   }
   return {type: LOG_IN, payload};
}

export function logVerificar(usuario) {
   let payload = {usuario: {}, logged: false, intentoVerificar: true};
   if (usuario && usuario.codigo) {
      payload.logged = true;
      payload.usuario = usuario;
   } else {
      payload.usuario = {};
   }
   return {
      type: LOG_VERIFICAR,
      payload
   };
}
